import React from 'react';
import { Link } from 'react-router-dom';
import { neighborhoodList } from '../data/neighborhoods';
import { guides } from '../data/guides';
import './LocalResourceLinks.css';

const featuredGuideSlugs = [
  'palm-beach-county-home-buying-guide',
  'first-time-home-buyer-palm-beach-county',
  'buying-luxury-home-south-florida',
  'florida-homeowners-insurance-guide',
  'fort-lauderdale-waterfront-home-guide',
  'brightline-commute-palm-beach-county'
];

const featuredGuides = featuredGuideSlugs.map((slug) => guides[slug]).filter(Boolean);
const cityAreaGuides = neighborhoodList.filter((area) => !area.isCommunity);

const LocalResourceLinks = ({ variant = 'default' }) => (
  <section className={`local-resource-links local-resource-links--${variant}`} aria-labelledby={`local-links-${variant}`}>
    <div className="local-resource-links__inner">
      <div className="local-resource-links__heading">
        <span>Explore Palm Beach &amp; South Florida</span>
        <h2 id={`local-links-${variant}`}>Local real estate resources</h2>
      </div>

      <div className="local-resource-links__group">
        <h3>Area guides</h3>
        <nav aria-label="Palm Beach and South Florida area guides">
          {cityAreaGuides.map((area) => (
            <Link key={area.slug} to={`/neighborhood/${area.slug}`}>{area.name}</Link>
          ))}
        </nav>
      </div>

      <div className="local-resource-links__group">
        <h3>Featured buyer guides</h3>
        <nav aria-label="Featured Palm Beach buyer guides">
          {featuredGuides.map((guide) => (
            <Link key={guide.slug} to={`/guide/${guide.slug}`}>{guide.title}</Link>
          ))}
        </nav>
      </div>
    </div>
  </section>
);

export default LocalResourceLinks;
